import axios from 'axios';
import { apiConfig } from '../config';

const instance = axios.create({
    baseURL: apiConfig.apiUrl,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true // This is important for CORS with credentials
});

// Add a request interceptor for handling multipart/form-data and auth
instance.interceptors.request.use(config => {
    // Handle FormData
    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    }

    // Add auth token if exists
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

// Add a response interceptor for error handling
instance.interceptors.response.use(
    response => response,
    error => {
        // Handle 401 (Unauthorized) errors
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance;
